import { theme } from '@/theme';

import type { IconAsset } from '../Icon.types';

export const newBadge: IconAsset = {
  bold: {
    l: {
      code: (
        <svg
          height='16'
          viewBox='0 0 23.074 16'
          width='23.074'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g transform='translate(-284.5 -80)'>
            <g transform='translate(276.5 83)'>
              <path
                d='M-4.11-8.16V0H-5.646l-1.8-4.932h-.036L-7.446,0H-8.91V-8.16H-7.4l1.824,4.908h.024L-5.586-8.16Zm5.6,6.708V0H-2.694V-8.16H1.494v1.452H-1.074v1.86H.234V-3.4H-1.074v1.944ZM9.474-8.16,7.914,0H6.57L5.634-4.848H5.61L4.626,0H3.294L1.83-8.16H3.462l.708,4.8h.012l.936-4.8H6.246L7.11-3.348h.024L7.926-8.16Z'
                fill='#0e2240'
                transform='translate(20 9)'
              />
            </g>
            <path
              d='M23.074.5H0v-1H23.074Z'
              fill={theme.colors.primary}
              transform='translate(284.5 95.5)'
            />
            <path
              d='M23.074.5H0v-1H23.074Z'
              fill={theme.colors.primary}
              transform='translate(284.5 80.5)'
            />
          </g>
        </svg>
      ),
    },
    m: {
      code: (
        <svg
          height='16'
          viewBox='0 0 23.074 16'
          width='23.074'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g transform='translate(-284.5 -80)'>
            <g transform='translate(276.5 83)'>
              <path
                d='M-4.11-8.16V0H-5.646l-1.8-4.932h-.036L-7.446,0H-8.91V-8.16H-7.4l1.824,4.908h.024L-5.586-8.16Zm5.6,6.708V0H-2.694V-8.16H1.494v1.452H-1.074v1.86H.234V-3.4H-1.074v1.944ZM9.474-8.16,7.914,0H6.57L5.634-4.848H5.61L4.626,0H3.294L1.83-8.16H3.462l.708,4.8h.012l.936-4.8H6.246L7.11-3.348h.024L7.926-8.16Z'
                fill='#0e2240'
                transform='translate(20 9)'
              />
            </g>
            <path
              d='M23.074.5H0v-1H23.074Z'
              fill={theme.colors.primary}
              transform='translate(284.5 95.5)'
            />
            <path
              d='M23.074.5H0v-1H23.074Z'
              fill={theme.colors.primary}
              transform='translate(284.5 80.5)'
            />
          </g>
        </svg>
      ),
    },
    s: {
      code: (
        <svg
          height='16'
          viewBox='0 0 23.074 16'
          width='23.074'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g transform='translate(-284.5 -80)'>
            <g transform='translate(276.5 83)'>
              <path
                d='M-4.11-8.16V0H-5.646l-1.8-4.932h-.036L-7.446,0H-8.91V-8.16H-7.4l1.824,4.908h.024L-5.586-8.16Zm5.6,6.708V0H-2.694V-8.16H1.494v1.452H-1.074v1.86H.234V-3.4H-1.074v1.944ZM9.474-8.16,7.914,0H6.57L5.634-4.848H5.61L4.626,0H3.294L1.83-8.16H3.462l.708,4.8h.012l.936-4.8H6.246L7.11-3.348h.024L7.926-8.16Z'
                fill='#0e2240'
                transform='translate(20 9)'
              />
            </g>
            <path
              d='M23.074.5H0v-1H23.074Z'
              fill={theme.colors.primary}
              transform='translate(284.5 95.5)'
            />
            <path
              d='M23.074.5H0v-1H23.074Z'
              fill={theme.colors.primary}
              transform='translate(284.5 80.5)'
            />
          </g>
        </svg>
      ),
    },
  },
  regular: {
    l: {
      code: (
        <svg
          height='16'
          viewBox='0 0 23.074 16'
          width='23.074'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g transform='translate(-284.5 -80)'>
            <g transform='translate(276.5 83)'>
              <path
                d='M-4.11-8.16V0H-5.646l-1.8-4.932h-.036L-7.446,0H-8.91V-8.16H-7.4l1.824,4.908h.024L-5.586-8.16Zm5.6,6.708V0H-2.694V-8.16H1.494v1.452H-1.074v1.86H.234V-3.4H-1.074v1.944ZM9.474-8.16,7.914,0H6.57L5.634-4.848H5.61L4.626,0H3.294L1.83-8.16H3.462l.708,4.8h.012l.936-4.8H6.246L7.11-3.348h.024L7.926-8.16Z'
                fill='#0e2240'
                transform='translate(20 9)'
              />
            </g>
            <path
              d='M23.074.5H0v-1H23.074Z'
              fill={theme.colors.primary}
              transform='translate(284.5 95.5)'
            />
            <path
              d='M23.074.5H0v-1H23.074Z'
              fill={theme.colors.primary}
              transform='translate(284.5 80.5)'
            />
          </g>
        </svg>
      ),
    },
    m: {
      code: (
        <svg
          height='16'
          viewBox='0 0 23.074 16'
          width='23.074'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g transform='translate(-284.5 -80)'>
            <g transform='translate(276.5 83)'>
              <path
                d='M-4.11-8.16V0H-5.646l-1.8-4.932h-.036L-7.446,0H-8.91V-8.16H-7.4l1.824,4.908h.024L-5.586-8.16Zm5.6,6.708V0H-2.694V-8.16H1.494v1.452H-1.074v1.86H.234V-3.4H-1.074v1.944ZM9.474-8.16,7.914,0H6.57L5.634-4.848H5.61L4.626,0H3.294L1.83-8.16H3.462l.708,4.8h.012l.936-4.8H6.246L7.11-3.348h.024L7.926-8.16Z'
                fill='#0e2240'
                transform='translate(20 9)'
              />
            </g>
            <path
              d='M23.074.5H0v-1H23.074Z'
              fill={theme.colors.primary}
              transform='translate(284.5 95.5)'
            />
            <path
              d='M23.074.5H0v-1H23.074Z'
              fill={theme.colors.primary}
              transform='translate(284.5 80.5)'
            />
          </g>
        </svg>
      ),
    },
    s: {
      code: (
        <svg
          height='16'
          viewBox='0 0 23.074 16'
          width='23.074'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g transform='translate(-284.5 -80)'>
            <g transform='translate(276.5 83)'>
              <path
                d='M-4.11-8.16V0H-5.646l-1.8-4.932h-.036L-7.446,0H-8.91V-8.16H-7.4l1.824,4.908h.024L-5.586-8.16Zm5.6,6.708V0H-2.694V-8.16H1.494v1.452H-1.074v1.86H.234V-3.4H-1.074v1.944ZM9.474-8.16,7.914,0H6.57L5.634-4.848H5.61L4.626,0H3.294L1.83-8.16H3.462l.708,4.8h.012l.936-4.8H6.246L7.11-3.348h.024L7.926-8.16Z'
                fill='#0e2240'
                transform='translate(20 9)'
              />
            </g>
            <path
              d='M23.074.5H0v-1H23.074Z'
              fill={theme.colors.primary}
              transform='translate(284.5 95.5)'
            />
            <path
              d='M23.074.5H0v-1H23.074Z'
              fill={theme.colors.primary}
              transform='translate(284.5 80.5)'
            />
          </g>
        </svg>
      ),
    },
  },
};
